import { pdf } from "@react-pdf/renderer";
import EvaluationPDF from "./EvaluationPDF";
import type { FormData, GeneratedContent } from "../types";

/**
 * Browser-side PDF generation flow:
 * 1) Render React-PDF document to Blob
 * 2) Create object URL
 * 3) Programmatically trigger file download
 *
 * Required because React-PDF does not provide a direct download API.
 */

export const normalizeN8nResponse = (data: any): GeneratedContent => {
  const item = Array.isArray(data) ? data[0] : data;

  if (item?.plano_aula && item?.avaliacao) {
    const objectiveQuestions =
      item.avaliacao.questoes_objetivas?.questoes || [];
    const essayQuestions =
      item.avaliacao.questoes_dissertativas?.questoes || [];

    return {
      orientacoes_professor: item.plano_aula.orientacoes_professor || [],
      estrutura_avaliacao: {
        questoes_objetivas: {
          valor_cada: item.avaliacao.questoes_objetivas?.valor_cada || "0.4",
          exemplos: objectiveQuestions.map((q: any) => ({
            numero: q.numero,
            enunciado: q.texto,
            alternativas: [
              `a) ${q.opcoes?.a || ""}`,
              `b) ${q.opcoes?.b || ""}`,
              `c) ${q.opcoes?.c || ""}`,
              `d) ${q.opcoes?.d || ""}`,
            ],
          })),
        },
        questoes_dissertativas: {
          exemplos: essayQuestions.map((q: any) => ({
            numero: q.numero,
            enunciado: q.texto,
            valor: q.valor || "2.00",
          })),
        },
      },
      habilidades_bncc: item.plano_aula.habilidades_bncc || [],
    };
  }

  return item;
};

export const downloadProvaAsPDF = async (
  formData: FormData,
  generatedContent: GeneratedContent,
  _userData?: any,
) => {
  try {
    // Normalize external payload to internal domain model
    const normalized = normalizeN8nResponse(generatedContent);

    // Render React-PDF document into a Blob
    const doc = <EvaluationPDF formData={formData} content={normalized} />;
    const blob = await pdf(doc).toBlob();

    // Create temporary link to trigger browser download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${formData.title || "Avaliacao"}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Erro ao gerar PDF:", error);
    alert("Erro ao gerar o arquivo PDF. Por favor, tente novamente.");
  }
};

export const printProva = () => {
  window.print();
};
